export const SIGN_IN = '/sign-in'
export const TRIAL_SIGNUP = '/trial-signup'
export const SIGN_IN_CALLBACK = '/sign-in/callback'
export const RESET_PASSWORD = '/reset-password'
export const NEW_PASSWORD = '/new-password'
export const SETUP_PASSWORD = '/setup-password'
export const VERIFY_USER = '/verify-user'
export const REQUEST_ACCESS = '/request-access'
